module.exports = __webpack_public_path__ + "img/136A9440.dac3356c.jpg";